import { scrollIntoViewIfNeeded } from '../utilities/scrollIntoViewIfNeeded.js';
import { styled, css } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import { createTransition } from '../utilities/create-transition.js';
import { useEffect, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import { darken } from '@vebox/etui-colors';
import InputLabel from '../InputLabel/InputLabel.js';

const _excluded = ["theme", "startInputAddon", "endInputAddon", "disabled", "readOnly", "menuIsOpen", "size", "borderColor"];
const ControlDiv = styled(Div).attrs(_ref => {
  let {
      theme,
      startInputAddon,
      endInputAddon,
      disabled,
      readOnly,
      menuIsOpen,
      size,
      borderColor
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const defaultBorderColor = theme.palette.grey[60];
  const activeBorderColor = theme.palette.grey[100];
  const disabledBorderColor = darken(theme.palette.action.disabledBackground, 0.1);
  const isBorderColorOverriding = borderColor ? borderColor !== defaultBorderColor : false;
  return _objectSpread2({
    position: 'relative',
    display: 'flex',
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: [theme.typography.pxToRem(16), theme.typography.pxToRem(16), theme.typography.pxToRem(14)],
    color: theme.palette.text.primary,
    bg: disabled ? theme.palette.action.disabledBackground : readOnly ? 'transparent' : theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: menuIsOpen ? 0 : theme.shape.borderRadius,
    borderBottomRightRadius: menuIsOpen ? 0 : theme.shape.borderRadius,
    boxShadow: disabled || readOnly ? 'none' : menuIsOpen ? theme.shadows[4] : 'unset',
    borderWidth: readOnly ? 0 : '1px',
    borderStyle: 'solid',
    borderColor: disabled ? disabledBorderColor : isBorderColorOverriding ? borderColor : menuIsOpen ? borderColor || activeBorderColor : defaultBorderColor,
    height: size === 'default' ? theme.shape.inputHeight : '42px',
    outline: 0,
    cursor: disabled ? 'not-allowed' : 'auto',
    hoverBorderColor: disabled ? disabledBorderColor : isBorderColorOverriding ? borderColor : activeBorderColor,
    hoverBoxShadow: '0px 0px 4px -1px rgba(0, 0, 0, 0.12), 0px 0px 4px 0px rgba(0, 0, 0, 0.08),0px 1px 10px 0px rgba(0, 0, 0, 0.06)',
    transition: createTransition(['border-color', 'box-shadow'], {
      duration: 'shorter'
    })
  }, rest);
})`
  ${({
  disabled,
  readOnly,
  hoverBorderColor,
  hoverBoxShadow
}) => {
  if (!disabled || !readOnly) {
    return css`
        &:hover {
          border-color: ${hoverBorderColor};
        }

        &:focus {
          border-color: ${hoverBorderColor};
          box-shadow: ${hoverBoxShadow};
        }
      `;
  }
  return ``;
}};
`;

const Control = ({
  isFocused,
  hasValue,
  children,
  innerProps,
  isMulti,
  selectProps: {
    disabled,
    readOnly,
    placeholder,
    menuIsOpen,
    name,
    startInputAddon,
    endInputAddon,
    size,
    customStyles,
    menuRef,
    useAutoScroll
  },
  innerRef
}) => {
  useEffect(() => {
    if (useAutoScroll && menuIsOpen && menuRef.current) {
      scrollIntoViewIfNeeded(menuRef.current);
    }
  }, [useAutoScroll, menuIsOpen, menuRef.current]);
  return /*#__PURE__*/createElement(ControlDiv, _extends({
    size: size,
    readOnly: readOnly,
    disabled: disabled,
    startInputAddon: startInputAddon,
    endInputAddon: endInputAddon,
    menuIsOpen: menuIsOpen,
    elRef: innerRef
  }, innerProps, isMulti && hasValue && {
    height: 'auto'
  }, customStyles.input), placeholder && /*#__PURE__*/createElement(InputLabel, _extends({
    htmlFor: name,
    shouldFloat: menuIsOpen || hasValue || isFocused,
    startInputAddon: startInputAddon,
    endInputAddon: endInputAddon,
    size: size
  }, customStyles.label), placeholder), children);
};

export default Control;
